import {
  AIProviderService,
  ensureAIProvider,
} from '@affine/core/blocksuite/ai/provider/ensure-provider';
import { useFramework, useLiveData, useService } from '@toeverything/infra';
import { useEffect, useState } from 'react';

export function useAIProviderReady(enabled = true): boolean {
  const framework = useFramework();
  const ready = useLiveData(useService(AIProviderService).ready$);
  const [error, setError] = useState<unknown>();
  useEffect(() => {
    if (!enabled) return;
    let current = true;
    ensureAIProvider(framework).catch(error => {
      if (current) setError(error);
    });
    return () => {
      current = false;
    };
  }, [enabled, framework]);
  if (error) throw error;
  return ready;
}
